import { withNavigation }      from 'components/App/withNavigation';
import { WithNavigationProps } from 'components/App/withNavigation';
import React                   from 'react';
import { observer }            from 'mobx-react';
import { EditOutlined }        from '@ant-design/icons';
import Row                     from 'components/App/Row';
import { DeleteOutlined }      from '@ant-design/icons';
import { Col }                 from 'antd';
import { Modal }               from 'antd';
import AdvertiserModel         from 'models/AdvertiserModel';
import currentSession          from 'utils/currentSession';
import { messageSuccessIntl }  from 'utils/messageIntl';
import { messageErrorIntl }    from 'utils/messageIntl';
import { formatMessageIntl }   from 'utils/messageIntl';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import DashboardComponent      from 'components/App/DashboardComponent';
import GridInfo                from 'components/App/GridInfo';
import DropDownMenu            from 'components/App/DropDownMenu';
import PageTitle               from 'components/App/PageTitle';
import rights                  from 'utils/rights';
import { AppForm }             from 'components/App/AppForm';
import AdvertiserForm          from 'forms/AdvertiserForm';

const LogoStyle = {
  backgroundPosition: 'center',
  backgroundSize: '100% auto',
  height: '300px',
  overflow: 'hidden',
  width: '300px',
};

@observer
class AdvertiserDashboard extends React.Component<WithNavigationProps> {
  public advertiser = new AdvertiserModel();

  public componentDidMount() {
    if (!currentSession.isAdmin) {
      this.props.navigate('/404');
      return;
    }

    this.fetchData();
  }

  public render() {
    return (
      <>
        <PageTitle title={<FormattedMessageWrapper id="Tableau de bord de l'annonceur" />} />

        <DashboardComponent
          body={<></>}
          dataLoading={false}
          headContent={this.renderHeadContent()}
          model={this.advertiser}
          title={this.renderTitle()}
          topRightComponent={this.renderTopRightComponent()}
        />
      </>
    );
  }

  public renderHeadContent = () => {
    const data = [
      [
        {
          label: <FormattedMessageWrapper id="Clics" />,
          value: this.advertiser.counter,
        },
        {
          label: <FormattedMessageWrapper id="Lien" />,
          value: this.advertiser.link,
        },
      ],
    ];

    return (
      <Row>
        <Col md={12} sm={24}>
          <div
            style={{
              ...LogoStyle,
              backgroundImage: `url(${this.advertiser.logoObjectUrl})`,
            }}
          />
        </Col>
        <Col md={12} sm={24}>
          <GridInfo data={data} />
        </Col>
      </Row>
    );
  };

  public renderTitle = () => this.advertiser.advertiserName;

  public renderTopRightComponent = () => {
    const items = [];

    if (rights.for.advertiser.edit) {
      items.push({
        icon: <EditOutlined />,
        key: 'EDIT',
        label: <FormattedMessageWrapper id="Modifier" />,
        onClick: () =>
          AppForm.open(
            AdvertiserForm,
            {
              model: this.advertiser,
              onSuccess: () => this.fetchData(),
            },
            { title: <FormattedMessageWrapper id="Modifier l'annonceur" /> },
          ),
      });
    }

    if (rights.for.advertiser.delete) {
      items.push({
        danger: true,
        icon: <DeleteOutlined />,
        key: 'DELETE',
        label: <FormattedMessageWrapper id="Supprimer" />,
        onClick: () =>
          Modal.confirm({
            cancelText: formatMessageIntl('Annuler'),
            content: formatMessageIntl("Êtes-vous sûr de vouloir supprimer cet annonceur ?"),
            okText: formatMessageIntl("Supprimer l'annonceur"),
            okType: 'danger',
            onOk: async () => {
              try {
                await this.advertiser.destroy();
                messageSuccessIntl('Suppression réussie !');
                this.props.navigate('/annonceurs');
              } catch {
                messageErrorIntl('Suppression impossible.');
              }
            },
            title: formatMessageIntl('Supprimer un annonceur'),
          }),
      });
    }

    if (!items.length) {
      return null;
    }

    return <DropDownMenu items={items} />;
  };

  private fetchData = () => {
    const { advertiserId } = this.props.params;
    this.advertiser.setId(advertiserId);
    this.advertiser.fetch();
  };
}

const WrappedAdvertiserDashboard = withNavigation(AdvertiserDashboard);

export default WrappedAdvertiserDashboard;
